import { useGridFilter } from 'ag-grid-react'
import { intl } from '../../../../../../../../i18n'
import { AttachmentSummary } from '../../../../../../../../utils/attachment'

const hasAttachmentLabel = intl.formatMessage({
  id: 'openDetail.hasAttachment',
})
const noAttachmentLabel = intl.formatMessage({
  id: 'openDetail.noAttachment',
})

const ALL_OPTIONS = [hasAttachmentLabel, noAttachmentLabel]

type AttachmentFilterModel = {
  value: string[]
}

const buildModel = (values: string[]): AttachmentFilterModel | null => {
  const isAllSelected = values.length === ALL_OPTIONS.length
  return isAllSelected ? null : { value: values }
}

interface Props {
  colDef?: {
    cellRendererParams: {
      getAttachmentSummary?: (row: any) => AttachmentSummary | undefined
    }
  }
  model: AttachmentFilterModel | null
  onModelChange: (model: AttachmentFilterModel | null) => void
}

export default (props: Props) => {
  const selectedValues: string[] = props.model?.value ?? ALL_OPTIONS

  const doesFilterPass = params => {
    if (!props.colDef?.cellRendererParams) {
      return true
    }
    if (!props.model) return true
    if (props.colDef.cellRendererParams.getAttachmentSummary) {
      const attachmentSummary =
        props.colDef.cellRendererParams.getAttachmentSummary(params.data)
      if (
        props.model.value.includes(hasAttachmentLabel) &&
        attachmentSummary?.hasAttachment
      ) {
        return true
      }
      if (
        props.model.value.includes(noAttachmentLabel) &&
        !attachmentSummary?.hasAttachment
      ) {
        return true
      }
    }
    return false
  }

  useGridFilter({ doesFilterPass })

  const onChange = event => {
    const checked = event.target.checked
    const value = event.target.name
    if (checked) {
      props.onModelChange(buildModel([...selectedValues, value]))
    } else {
      props.onModelChange(buildModel(selectedValues.filter(v => v !== value)))
    }
  }

  return (
    <div
      style={{
        minHeight: 100,
        padding: 2,
      }}
    >
      {ALL_OPTIONS.map(option => (
        <div
          key={option}
          style={{
            height: 23,
          }}
        >
          <input
            type="checkbox"
            key={option}
            id={option}
            name={option}
            style={{
              width: 15,
              height: 15,
              color: '#0091ea',
              backgroundColor: '#ffffff',
              verticalAlign: 'middle',
            }}
            checked={selectedValues.includes(option)}
            onChange={onChange}
          />
          <label
            htmlFor={option}
            style={{
              verticalAlign: 'middle',
            }}
          >
            {option}
          </label>
        </div>
      ))}
    </div>
  )
}
